import React from "react";
import "./patientReceiptStyles.css";
import usePagination from "hooks/usePagination";
import { fetchPatientReceiptData } from "services/patientappointmentdetails";
import { DEFAULT_TOTAL_RECORDS, STALE_TIME } from "utils/constants";
import Loader from "components/Common/loader";
import { useQuery } from "@tanstack/react-query";
import generatedFormatDate from "../../utils/generatedDate";

const TRFWorkSheet = () => {
  const { currentPage, updateTotalRecords } = usePagination();
  const receiptData = JSON.parse(localStorage.getItem("receiptPatient"));

  const formatUnixTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(",", "");
  };

  const { data: cashReceiptData, isLoading } = useQuery(
    ["fetch-cash-patient-receipt"],
    () => fetchPatientReceiptData({ appointment_id: receiptData }),
    {
      staleTime: STALE_TIME,
      onSuccess: (res) =>
        updateTotalRecords(res?.data?.additional_data?.total_count),
      select: (res) => {
        const response = res?.data?.data;
        if (response && response.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => console.error("Error fetching payments:", res),
      enabled: !!receiptData,
    }
  );

  const convertSecondsToAge = (seconds) => {
    const years = Math.floor(seconds / 31536000);
    const months = Math.floor((seconds % 31536000) / 2629746);
    const days = Math.floor(((seconds % 31536000) % 2629746) / 86400);
    return `${years} Y`;
  };

  const {
    patient_obj = {},
    refer_doctor_obj = {},
    franchise_obj = {},
    appointment_investigation_obj = [],
    id = "N/A",
    reg_date = "N/A",
    reg_no = "N/A",
    gender = "N/A",
    referred_by = "N/A",
    barcode = "N/A",
    address = "N/A",
    investigations = [],
    created_by = "N/A",
    current_datetime = new Date().toLocaleString(),
  } = cashReceiptData?.data[0] || {};

  const rowCashReceiptData = cashReceiptData?.data[0];

  const ageDetails = convertSecondsToAge(patient_obj.age || 0);
  const printReceipt = () => window.print();

  if (!cashReceiptData || isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  console.log("rowCash", rowCashReceiptData);

  return (
    <div className="receipt-container-unique">
      <div className="receipt-wrapper-unique">
        <div className="receipt-inner-unique">
          <div className="d-flex align-items-center mb-2">
            <div className="logo col-4">
              <img
                src="../assets/img/medicity_logo.png"
                alt="Medicity"
                width={135}
                height={90}
              />
            </div>
            <h3 className="receipt-header-unique col-8 d-flex align-items-center">
              FOR LABORATORY USE ONLY
            </h3>
          </div>
          <hr />
          <div className="row p-2">
            <div className="col-md-6 col-6">
              <div className="receipt-detail-unique">
                Patient Name: <span>{patient_obj.patient_name}</span>
              </div>
              <div className="receipt-detail-unique">
                Lab Name.: <span>{rowCashReceiptData?.lab_name}</span>
              </div>
              <div className="receipt-detail-unique">
                Reg. Date:{" "}
                <span>
                  {generatedFormatDate(
                    rowCashReceiptData?.patient_obj?.generated
                  )}
                </span>
              </div>
              <div className="receipt-detail-unique">
                Mobile No.: <span>{patient_obj?.mobile || "N/A"}</span>
              </div>
            </div>
            <div className="col-6 col-md-6">
              <div className="receipt-detail-unique">
                Reg. No.: <span>{id}</span>
              </div>
              <div className="receipt-detail-unique">
                Age/Gender:{" "}
                <span>
                  {ageDetails} /{" "}
                  {patient_obj.gender === "female"
                    ? "F"
                    : patient_obj.gender === "male"
                    ? "M"
                    : "O"}
                </span>
              </div>
              <div className="receipt-detail-unique">
                Referred By:{" "}
                <span>{rowCashReceiptData?.refer_doctor_name}</span>
              </div>
              <div className="receipt-detail-unique">
                Barcode No.:{" "}
                <span>{appointment_investigation_obj[0].barcode_no}</span>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="receipt-detail-unique">
              Address: <span>{franchise_obj?.address || "N/A"}</span>
            </div>
          </div>
          <hr />
          <div className="d-flex flex-row justify-content-center p-2">
            <div className="receipt-detail-unique">Sample Collected By</div>
          </div>
          <div className="d-flex flex-row p-2">
            <div className="receipt-detail-unique">
              Record .......................................
            </div>
            <div className="receipt-detail-unique">
              Technician ...................................
            </div>
            <div className="receipt-detail-unique">
              Time .........................................
            </div>
          </div>
          <div className="d-flex flex-row p-2 align-items-center receipt-detail-sample-type">
            <div className="sample-type-label col-2">Sample Type:</div>
            <div className="sample-type-boxes col-10 justify-content-space-around">
              <div className="sample-type-item">
                <div>Blood</div>
                <div className="sample-type-box"></div>
              </div>
              <div className="sample-type-item">
                <div>Urine</div>
                <div className="sample-type-box"></div>
              </div>
              <div className="sample-type-item">
                <div>Stool</div>
                <div className="sample-type-box"></div>
              </div>
              <div className="sample-type-item">
                <div>Others</div>
                <div className="sample-type-box"></div>
              </div>
            </div>
          </div>
          <hr />
          <h4>Investigations</h4>
          <table className="receipt-table-unique">
            <thead>
              <tr className="receipt-colheaders-unique">
                <th>Sr. No.</th>
                <th>Test Name (Sample Req)</th>
                <th>Results/Observations</th>
                <th>Technician Date Time</th>
              </tr>
            </thead>
            <tbody>
              {appointment_investigation_obj.length > 0 ? (
                appointment_investigation_obj?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.investigation.investigation_name || "N/A"}</td>
                    <td></td>
                    <td></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No investigations found</td>
                </tr>
              )}
            </tbody>
          </table>
          <hr />
          <h4>Patient History</h4>
          <div className="d-flex flex-row">
            <div className="receipt-detail-unique col-6">Received By:</div>
            <div className="receipt-detail-unique col-6">Received Date:</div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="receipt-detail-unique">
              Created By: <span>{created_by}</span>
            </div>
            <div className="receipt-detail-unique">
              Date/Time: <span>{current_datetime}</span>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn"
              style={{ background: "#11598f", color: "#fff" }}
              onClick={printReceipt}
            >
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TRFWorkSheet;
